import { render } from "./PdpaContent.vue?vue&type=template&id=f7fc12a2"
import script from "./PdpaContent.vue?vue&type=script&lang=js"
export * from "./PdpaContent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\_work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__